import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { getNoDefaultFilters } from '~src/contentDefinitions/getDefaultFilters';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { GroupContentType } from '~src/spacesPlatform/models/ContentTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { ConnectedApplications } from '../resources/ConnectedApplicationsResource';


export const ConnectedApplicationDefinition: ExplorableItemDefinition & SpaceDefinition<'connectedApplication'>  = {
  headerIconPath: () => '', // No page should be making use of this
  contentType: 'connectedApplication',
  itemType: 'connectedApplication',
  singularName: () => Messages.connectedApplication(),
  pluralName: () => Messages.connectedApplications(),
  emptyStateMessage: () => Messages.connectedApplicationsEmptyMessage(),
  contentSpaceUrl: (urls: SpacesSiteUrls, id: string) => urls.connectedApplicationUrl(id),
  contentFilterKeys: GroupContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null, // No page should be making use of this
  filterClause: ServerFilterClauses.ContentType(['connectedApplication']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return ConnectedApplications.all();
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
